import { apiInstance } from "./ApiInstance";

export const getClaimDetails = async (claimNumber) => {
  let { data = {} } = await apiInstance.get(
    `api/case/create-case?claimNumber=${claimNumber}`
  );
  return data;
};
export const addCase = async (payload) => {
  let { data = {} } = await apiInstance.post(`api/case/create-case`, payload);
  return data;
};
